import { Type } from '@angular/core';
import { FieldType } from '../models/field-schema.model';

/**
 * Field component registry
 * Maps field types to component classes for dynamic loading
 */
export class FieldRegistry {
  private static registry: Map<FieldType, Type<any>> = new Map();

  /**
   * Register a component for a field type
   */
  static register(fieldType: FieldType, componentClass: Type<any>): void {
    if (this.registry.has(fieldType)) {
      console.warn(`Field type "${fieldType}" is already registered. Overwriting...`);
    }
    this.registry.set(fieldType, componentClass);
  }

  /**
   * Get component class for a field type
   */
  static get(fieldType: FieldType): Type<any> | undefined {
    return this.registry.get(fieldType);
  }

  /**
   * Check if a field type is registered
   */
  static has(fieldType: FieldType): boolean {
    return this.registry.has(fieldType);
  }

  /**
   * Get all registered field types
   */
  static getRegisteredTypes(): FieldType[] {
    return Array.from(this.registry.keys());
  }

  /**
   * Clear all registrations (useful for testing)
   */
  static clear(): void {
    this.registry.clear();
  }

  /**
   * Initialize default field components
   * Called once at application startup
   * Note: This will be populated when components are ready
   */
  static initializeDefaults(): void {
    // Components will self-register or be registered in app initialization
    // This method is reserved for future use
  }
}
